import { render, staticRenderFns } from "./model-welcomeVideo.vue?vue&type=template&id=06131c18&scoped=true&"
import script from "./model-welcomeVideo.vue?vue&type=script&lang=js&"
export * from "./model-welcomeVideo.vue?vue&type=script&lang=js&"
import style0 from "./model-welcomeVideo.vue?vue&type=style&index=0&id=06131c18&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06131c18",
  null
  
)

export default component.exports